import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { catchError, getUserDataFromJwt } from "@_utils/helpers";

import AppSnackbar from "@_components/AppSnackbar/AppSnackbar";
import { useSnackbar } from "@_hooks/useSnackbar";
import UpgradePlanpopup from "@_components/popups/UpgradePlanPopup/UpgradePlanPopup.js";
import UpgradeImage from "@_assets/images/add_email_flows.png";
import subscriptionCopy from "@_configs/subscription.config.js";
import styles from "./CaseTemplates.module.css";
import CaseTemplateRow from "../CaseTemplateRow/CaseTemplateRow";
import { caseTemplateActions } from "@_actions/caseTemplate.actions";
import { languageActions } from "@_actions/language.actions";
import CaseTemplateEditor from "@_components/CaseTemplateEditor/CaseTemplateEditor";
import { Button } from "@mui/material";
import SingleTextInputPopup from "@_components/popups/SingleTextInputPopup/SingleTextInputPopup";
import Scrollbar from "react-perfect-scrollbar-z";
import "scrollbar.css";
import { sidebarActions } from "@_actions/sidebar.actions";
import { sidebarConstants } from "@_constants/sidebar.constants";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

function CaseTemplates() {
  const dispatch = useDispatch();

  const jwtData = getUserDataFromJwt();

  const caseTemplateReducer = useSelector((state) => state.caseTemplateReducer);
  const [newCaseTemplate, setNewCaseTemplate] = useState({
    name: "",
  });
  const [displayUpgrade, setDisplayUpgrade] = useState(false);
  const [isAddTemplateDialogOpen, setIsAddTemplateDialogOpen] = useState(false);
  const { snackbarProps, showSnackbarSuccess, showSnackbarError } =
    useSnackbar();
  const { title, subtitle, copy_1, upgradeButton } =
    subscriptionCopy.emailFlow[jwtData.subscription.toLowerCase()];

  const history = useHistory();
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  useEffect(() => {
    dispatch(languageActions.getTranslations());
    dispatch(caseTemplateActions.getCaseTemplates());
    dispatch(sidebarActions.updateStatus(sidebarConstants.CASETEMPLATES));
    return () => {
      dispatch(caseTemplateActions.selectCaseTemplate(null));
    };
  }, [dispatch]);

  useEffect(() => {
    if (caseTemplateReducer.status.CASETEMPLATE_GET === "success") {
      dispatch(caseTemplateActions.clearStatusMessage("CASETEMPLATE_GET"));
      if (pathParts.length === 3 && pathParts[1] === "case_auto_fill") {
        if (
          !caseTemplateReducer.caseTemplates.some((x) => x.id === pathParts[2])
        ) {
          history.push("/page_not_found");
        } else {
          dispatch(caseTemplateActions.selectCaseTemplate(pathParts[2]));
          history.push(`/templates/case_auto_fill/${pathParts[2]}`);
        }
      }
    } else if (catchError(caseTemplateReducer.status.CASETEMPLATE_GET)) {
      showSnackbarError(caseTemplateReducer.status.CASETEMPLATE_GET);
      dispatch(caseTemplateActions.clearStatusMessage("CASETEMPLATE_GET"));
    } else return;
    // eslint-disable-next-line
  }, [
    dispatch,
    history,
    caseTemplateReducer.status.CASETEMPLATE_GET,
    showSnackbarError,
  ]);

  const handleInputChange = (e) => {
    var value = e.target.value;
    setNewCaseTemplate((newTemplate) => ({
      ...newTemplate,
      name: value,
    }));
  };

  const handleSubmitInput = (e) => {
    e.preventDefault();
    if (newCaseTemplate.name) {
      dispatch(caseTemplateActions.selectCaseTemplate());
      dispatch(
        caseTemplateActions.addCaseTemplate({
          name: newCaseTemplate.name,
        }),
      );
    }
    setNewCaseTemplate({ name: "" });
  };

  const handleCloseAddTemplatePopup = () => {
    setNewCaseTemplate({
      name: "",
    });
    setIsAddTemplateDialogOpen(false);
  };

  // ERROR AND SUCCESS MESSAGES pcase

  // display add template POST success & error
  useEffect(() => {
    if (caseTemplateReducer.status.CASETEMPLATE_ADD === "success") {
      showSnackbarSuccess("Success!");
      handleCloseAddTemplatePopup();
      dispatch(caseTemplateActions.getCaseTemplates());
      dispatch(caseTemplateActions.clearStatusMessage("CASETEMPLATE_ADD"));
    } else if (catchError(caseTemplateReducer.status.CASETEMPLATE_ADD)) {
      showSnackbarError(caseTemplateReducer.status.CASETEMPLATE_ADD);
      dispatch(caseTemplateActions.clearStatusMessage("CASETEMPLATE_ADD"));
    } else return;
  }, [
    dispatch,
    caseTemplateReducer.status.CASETEMPLATE_ADD,
    showSnackbarError,
    showSnackbarSuccess,
  ]);

  // display edit template  success & error
  useEffect(() => {
    if (caseTemplateReducer.status.CASETEMPLATE_UPDATE === "success") {
      showSnackbarSuccess("Success!");
      dispatch(caseTemplateActions.getCaseTemplates());
      dispatch(caseTemplateActions.clearStatusMessage("CASETEMPLATE_UPDATE"));
    } else if (catchError(caseTemplateReducer.status.CASETEMPLATE_UPDATE)) {
      showSnackbarError(caseTemplateReducer.status.CASETEMPLATE_UPDATE);
      dispatch(caseTemplateActions.clearStatusMessage("CASETEMPLATE_UPDATE"));
    } else return;
  }, [
    dispatch,
    caseTemplateReducer.status.CASETEMPLATE_UPDATE,
    showSnackbarError,
    showSnackbarSuccess,
  ]);

  // display email DELETE success & error
  // display edit template  success & error
  useEffect(() => {
    if (caseTemplateReducer.status.CASETEMPLATE_DELETE === "success") {
      showSnackbarSuccess("Success!");
      dispatch(caseTemplateActions.getCaseTemplates());
      dispatch(caseTemplateActions.clearStatusMessage("CASETEMPLATE_DELETE"));
    } else if (catchError(caseTemplateReducer.status.CASETEMPLATE_DELETE)) {
      showSnackbarError(caseTemplateReducer.status.CASETEMPLATE_DELETE);
      dispatch(caseTemplateActions.clearStatusMessage("CASETEMPLATE_DELETE"));
    } else return;
  }, [
    dispatch,
    caseTemplateReducer.status.CASETEMPLATE_DELETE,
    showSnackbarError,
    showSnackbarSuccess,
  ]);

  return (
    <div className={styles.root}>
      <AppSnackbar {...snackbarProps} />

      <div className={styles.template_list_container}>
        <Scrollbar maxHeight="calc(100vh - 140px)" height="calc(100vh - 140px)">
          <div className={styles.add_template_container}>
            <Button
              style={{ backgroundColor: "white" }}
              onClick={() => {
                dispatch(caseTemplateActions.selectCaseTemplate(null));
                history.push("/templates/case_auto_fill");
                setIsAddTemplateDialogOpen(true);
              }}
              variant="outlined"
            >
              Add Case Template
            </Button>
          </div>
          {caseTemplateReducer.caseTemplates &&
            caseTemplateReducer.caseTemplates.map((caseTemplate, index) => {
              return (
                <CaseTemplateRow
                  data={caseTemplate}
                  key={caseTemplate.id}
                  index={index}
                  styles={styles}
                  name={caseTemplate.name}
                  handleSubmitInput={handleSubmitInput}
                  handleInputChange={handleInputChange}
                />
              );
            })}
        </Scrollbar>
      </div>

      {/* new template */}
      <div className={styles.template_container}>
        {/* existing template */}
        {caseTemplateReducer.selectedCaseTemplate &&
        Object.keys(caseTemplateReducer.selectedCaseTemplate).length !== 0 ? (
          <CaseTemplateEditor
            data={caseTemplateReducer.caseTemplates.find(
              (x) => x.id === caseTemplateReducer.selectedCaseTemplate,
            )}
            key={caseTemplateReducer.selectedCaseTemplate}
          />
        ) : null}

        {(caseTemplateReducer.selectedCaseTemplate &&
          Object.keys(caseTemplateReducer.selectedCaseTemplate).length === 0 &&
          !caseTemplateReducer.add_template) ||
        (!caseTemplateReducer.selectedCaseTemplate &&
          !caseTemplateReducer.add_template) ? (
          <div className={styles.template_no_data}>
            NO TEMPLATE IS SELECTED!
          </div>
        ) : null}
      </div>
      {displayUpgrade && (
        <UpgradePlanpopup
          title={title}
          subtitle={subtitle}
          upgradeButton={upgradeButton}
          copy_1={copy_1}
          imageUrl={UpgradeImage}
          open={displayUpgrade}
          close={() => setDisplayUpgrade(false)}
        />
      )}

      <SingleTextInputPopup
        title={"Add Case Template"}
        open={isAddTemplateDialogOpen}
        onClose={handleCloseAddTemplatePopup}
        handleTextChange={handleInputChange}
        required={true}
        helperText={"Name must be set for the new template"}
        onSubmit={handleSubmitInput}
        placeholder={"Enter case template name"}
        submitButtonText={"Create"}
        textInputLabel={"Name"}
      ></SingleTextInputPopup>
    </div>
  );
}

export default CaseTemplates;
